import { gql } from 'graphql-tag';
import { CAROUSEL_DEEP_FRAGMENT, } from '@annunciate/query/dist/queries/carousel';
import { COLLECTION_SHALLOW_FRAGMENT, } from '@annunciate/query/dist/queries/collection';
import { CONTENT_SHALLOW_FRAGMENT, } from '@annunciate/query/dist/queries/content';
export const COLLECTION_ITEM_SHALLOW_FRAGMENT = `
  fragment CollectionItemShallowFragment on CollectionItem {
    __typename
    id
    position
    parentId
    depth
    item {
      ... on Carousel {
        ...CarouselDeepFragment
      }
      ... on Collection {
        ...CollectionShallowFragment
      }
      ... on Content {
        ...ContentShallowFragment
      }
    }
  }
`;
export const COLLECTION_ITEMS_GET = gql `
  ${CAROUSEL_DEEP_FRAGMENT}
  ${COLLECTION_SHALLOW_FRAGMENT}
  ${CONTENT_SHALLOW_FRAGMENT}
  ${COLLECTION_ITEM_SHALLOW_FRAGMENT}
  query allCollectionItems(
    $parentId: ID!,
    $displayMode: DisplayMode!,
    $terminatingTypes: [CollectionItemType!],
    $perPage: Int,
    $page: Int,
    $sortField: String,
    $sortOrder: String,
    $playbackFilter: PlaybackFilter,
  ) {
    items: allCollectionItems(
      parentId: $parentId,
      displayMode: $displayMode,
      terminatingTypes: $terminatingTypes,
      perPage: $perPage,
      page: $page,
      sortField: $sortField,
      sortOrder: $sortOrder,
      playbackFilter: $playbackFilter,
    ) {
      ...CollectionItemShallowFragment
    }

    meta: _allCollectionItemsMeta(
      parentId: $parentId,
      displayMode: $displayMode,
      terminatingTypes: $terminatingTypes,
      perPage: $perPage,
      page: $page,
      sortField: $sortField,
      sortOrder: $sortOrder,
      playbackFilter: $playbackFilter,
    ) {
      count
      pageCount
      page
      nextPage
      prevPage
      perPage
    }
  }
`;
export const PLAYLIST_ITEMS_GET = gql `
  query allPlaylistItems(
    $parentId: ID!,
    $displayMode: DisplayMode!,
    $perPage: Int,
    $page: Int,
    $sortField: String,
    $sortOrder: String,
    $playbackFilter: PlaybackFilter,
  ) {
    items: allCollectionItems(
      parentId: $parentId,
      displayMode: $displayMode,
      perPage: $perPage,
      page: $page,
      sortField: $sortField,
      sortOrder: $sortOrder,
      playbackFilter: $playbackFilter,
    ) {
      __typename
      id
      position
      item {
        ... on Content {
          id
        }
      }
    }
  }
`;
export const COLLECTION_ITEM_APPEARS_IN = gql `
  query appearsIn(
    $type: CollectionItemType!,
    $id: ID!,
  ) {
    appearsIn(
      type: $type,
      id: $id,
    ) {
      id
      createdAt
      parent {
        ...CollectionShallowFragment
      }
    }
  }
  ${COLLECTION_SHALLOW_FRAGMENT}
`;
//# sourceMappingURL=collectionItem.js.map